/* src/app/shared/artificial-intelligence/chat/chat.component.scss */
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
  --bubble-radius: 16px;
  --bubble-shadow: 0 1px 2px rgba(0,0,0,.06), 0 2px 8px rgba(0,0,0,.06);
}
:host(.large-screen) {
  width: 100%;
  min-width: 0;
}
.header-bar {
  display: grid;
  grid-template-columns: 44px 1fr 44px;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  width: 100%;
  box-sizing: border-box;
  min-width: 0;
}
.header-title {
  margin: 0;
  font-weight: 700;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  font-size: 2rem;
  grid-column: 2;
  color: var(--color-accent, #f6a64b);
}
.header-title-icon {
  font-size: 1.5em;
  color: inherit;
  flex-shrink: 0;
}
.header-gear {
  grid-column: 1;
  justify-self: start;
}
.header-close {
  grid-column: 3;
  margin-right: 4px;
  justify-self: end;
}
:host ::ng-deep .gear-select mat-select,
:host ::ng-deep .gear-select .mat-mdc-select {
  min-width: 0 !important;
  padding: 0 !important;
  background: transparent !important;
}
:host ::ng-deep .gear-select .mat-mdc-form-field {
  width: 40px !important;
}
:host ::ng-deep .gear-select .mat-mdc-text-field-wrapper {
  background: transparent !important;
  box-shadow: none !important;
  padding: 0 !important;
}
:host ::ng-deep .gear-select .mat-mdc-form-field-flex,
:host ::ng-deep .gear-select .mat-mdc-form-field-infix {
  padding: 0 !important;
  margin: 0 !important;
  min-height: 0 !important;
  width: 40px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}
:host ::ng-deep .gear-select .mat-mdc-select-arrow-wrapper {
  display: none !important;
}
:host ::ng-deep .gear-select .mat-mdc-select-trigger {
  height: 36px !important;
  width: 36px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  margin: 0 !important;
  padding: 0 !important;
}
:host ::ng-deep .gear-select fa-icon,
:host ::ng-deep .gear-select .svg-inline--fa {
  font-size: 18px !important;
  color: #3a3a3a !important;
  line-height: 1;
}
::ng-deep .cdk-overlay-container .gear-panel.mat-mdc-select-panel {
  width: 340px !important;
  min-width: 340px !important;
  box-sizing: border-box;
  padding-left: 8px;
}
::ng-deep .gear-panel .mat-mdc-option .mdc-list-item__primary-text {
  white-space: normal;
}
::ng-deep .gear-panel .mat-mdc-optgroup .mat-mdc-optgroup-label {
  font-weight: 600;
  padding: 4px 0;
}
::ng-deep .cdk-overlay-pane.ai-chat-dialog {
  width: 40%;
  height: 70%;
  max-width: none !important;
  max-height: 100% !important;
  resize: none;
  overflow: visible;
  border-radius: 16px !important;
  background: transparent;
  box-shadow: 0 22px 60px rgba(15, 23, 42, 0.16);
}
::ng-deep .cdk-overlay-pane.ai-chat-dialog > .mat-mdc-dialog-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  resize: none;
  overflow: visible;
  border-radius: 16px !important;
  box-shadow: none;
  background: transparent;
  padding: 0;
  scrollbar-width: auto;
  scrollbar-color: rgba(0, 0, 0, 0.45) #fff;
}
::ng-deep .cdk-overlay-pane.ai-chat-dialog > .mat-mdc-dialog-container::-webkit-scrollbar {
  width: 12px;
}
::ng-deep .cdk-overlay-pane.ai-chat-dialog > .mat-mdc-dialog-container::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.45);
  border-radius: 8px;
  border: 3px solid #fff;
}
::ng-deep .cdk-overlay-pane.ai-chat-dialog > .mat-mdc-dialog-container::-webkit-scrollbar-track {
  background: #fff;
}
::ng-deep .ai-chat-dialog .chat-root {
  display: flex;
  flex-direction: column;
  height: 100%;
}
::ng-deep .ai-chat-dialog .header-bar {
  flex: 0 0 auto;
}
::ng-deep .ai-chat-dialog .content-container {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0 12px;
}
::ng-deep .ai-chat-dialog .chat-scroll {
  overflow-y: auto !important;
  overflow-x: hidden !important;
  flex: 1 1 auto !important;
  min-height: 0 !important;
}
.chat-body {
  display: flex !important;
  flex-direction: column !important;
  flex: 1 1 auto !important;
  min-height: 0 !important;
  overflow: hidden !important;
}
.chat-scroll {
  overflow-y: auto !important;
  overflow-x: hidden !important;
  flex: 1 1 auto !important;
  min-height: 0 !important;
}
::ng-deep .ai-chat-dialog .chat-input {
  flex: 0 0 auto;
}
.chat-root {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 100%;
  width: 100%;
  position: relative;
  overflow: hidden;
  background: #fff;
  border-radius: 16px !important;
  box-shadow: none;
}
.header-bar,
mat-divider {
  flex: 0 0 auto;
}
.content-container {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-items: stretch;
  gap: 24px;
  background-color: var(--background-color, #fff);
  padding-top: 24px;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
}
.chat-window {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.input-container {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
  gap: 12px;
  width: 100%;
  padding: 24px;
  background-color: var(--background-color, #fff);
}
.chat-input {
  flex: 0 0 auto;
  position: static;
  width: 100%;
  z-index: 2;
  background: #fff;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
  box-sizing: border-box;
  padding: 12px 24px 24px;
}
.input-wrapper {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  border: 1px solid rgba(15, 23, 42, 0.12);
  border-radius: 24px;
  background: #fff;
  padding: 18px 72px 56px 24px;
  box-shadow: 0 8px 24px rgba(17, 24, 39, 0.08);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  box-sizing: border-box;
}
.input-wrapper.input-focused {
  border-color: var(--color-accent, #f6a64b);
  box-shadow: 0 12px 32px rgba(246, 166, 75, 0.2);
}
.input-wrapper .button-send {
  position: absolute;
  right: 18px;
  bottom: 18px;
}
.input-textarea,
.preset {
  width: 100%;
  flex: 1 1 auto;
  align-self: stretch;
  font-size: 14px;
  line-height: 1.5;
  min-height: 44px;
  max-height: 240px;
  border: 0;
  padding: 0;
  margin: 0;
  background: transparent;
  color: var(--color-default-dark, #1f2937);
  resize: none;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}
.input-textarea::placeholder {
  color: rgba(31, 41, 55, 0.45);
  opacity: 1;
}
.input-textarea:focus {
  outline: none;
}
.input-wrapper .button-send,
.button-send {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin: 0;
  background: var(--color-accent, #f6a64b);
  box-shadow: 0 6px 18px rgba(246, 166, 75, 0.24);
}
.button-send .mat-mdc-button-touch-target {
  width: 48px;
  height: 48px;
  border-radius: 50%;
}
.button-send fa-icon,
.button-send .icon-button {
  font-size: 16px;
  color: #fff;
}
.button-send fa-icon svg,
.button-send .icon-button svg,
.button-send .svg-inline--fa {
  width: 16px;
  height: 16px;
  font-size: 16px;
}
.pro-analyze-toggle {
  position: absolute;
  left: 24px;
  bottom: 20px;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 0;
  border: 0;
  background: transparent;
  font-weight: 600;
  font-size: 14px;
  color: #A7A9AA;
  cursor: pointer;
  transition: color 0.2s ease, transform 0.2s ease;
}
.pro-analyze-toggle fa-icon {
  font-size: 20px;
}
.pro-analyze-toggle:hover {
  color: #8E9091;
}
.pro-analyze-toggle:focus-visible {
  outline: none;
  color: var(--color-accent, #f6a64b);
}
.pro-analyze-toggle.is-active {
  color: var(--color-accent, #f6a64b);
}
.pro-analyze-toggle.is-active fa-icon {
  color: inherit;
}
.message {
  display: grid;
  grid-template-columns: 32px 1fr 32px;
  grid-template-rows: auto auto auto;
  align-items: start;
  gap: 6px 12px;
  padding: 10px 12px;
  max-width: 100%;
}
.message > .message-col {
  display: contents;
}
.message-icon {
  grid-column: 1;
  grid-row: 1/span 2;
  font-size: 1.5em;
}
.message-icon.empty-icon {
  width: 24px;
  height: 24px;
}
.message-icon.fa-spin {
  animation: fa-spin 2s infinite linear;
  transform-origin: center center;
  display: inline-block;
  backface-visibility: hidden;
  position: relative;
  align-self: start;
  justify-self: center;
}
@keyframes fa-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.icon-button,
.response-icon {
  color: #ec913b;
}
.message-time {
  grid-column: 2;
  grid-row: 1;
  justify-self: end;
  font-size: 12px;
  line-height: 1.2;
  color: #1f2937;
  width: auto;
  max-width: 100%;
  margin: 0;
}
.user-message,
.other-message {
  grid-column: 2/4;
  grid-row: 2;
  padding: 12px 14px;
  border-radius: var(--bubble-radius);
  box-shadow: var(--bubble-shadow);
  max-width: 100%;
  overflow-wrap: anywhere;
  word-break: break-word;
  font-size: 14px;
  line-height: 1.5;
}
.user-message {
  background: var(--color-accent-light, #fde5c6);
  color: var(--color-default-dark, #1f2937);
  justify-self: end;
}
.other-message {
  background: var(--color-primary-light, #eef2f6);
  color: var(--color-default-dark, #1f2937);
  justify-self: start;
  text-align: left;
}
.message-col.align-right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.message-col.align-right .message-time {
  grid-column: 2/4;
  grid-row: 1;
  justify-self: end;
  text-align: right;
  margin-right: 0;
}
.other-message + .message-time {
  justify-self: start;
  text-align: left;
}
.message-meta {
  grid-column: 2;
  grid-row: 1;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  max-width: 100%;
}
.message-meta.user {
  justify-self: end;
  text-align: right;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  width: 100%;
  margin-bottom: 2px;
}
.message-meta.ai {
  justify-self: start;
  text-align: left;
}
.message-name {
  font-size: 13px;
  font-weight: 600;
  color: #111827;
  letter-spacing: 0.01em;
}
.content-container .message:first-child {
  margin-top: 6px;
}
.message button[mat-icon-button] {
  grid-column: 3;
  grid-row: 2;
  align-self: center;
  justify-self: end;
  margin: 0;
}
.message-actions {
  grid-column: 2/4;
  grid-row: 3;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 2px 4px 0 0;
  justify-self: start;
}
.message-action-btn {
  border-radius: 50%;
  color: #6b7280;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  min-width: 24px;
  min-height: 24px;
  padding: 0;
  line-height: 1;
  --mdc-icon-button-state-layer-size: 24px;
  --mat-icon-button-state-layer-size: 24px;
}
.message-action-btn fa-icon {
  font-size: 12px;
}
.message-action-btn:hover {
  color: #111827;
}
.suggestions-title {
  text-align: center;
  font-weight: 700;
  letter-spacing: 0.02em;
  margin: 8px 0 12px;
  width: 100%;
}
.suggestion {
  display: block;
  margin: 16px auto;
  width: clamp(260px, 80%, 680px);
  text-align: center;
  white-space: normal;
  max-width: 80%;
  padding: 24px;
  border-radius: 24px;
  background-color: #f9f9f9;
  cursor: pointer;
  transition: transform 0.2s ease-in-out;
}
.suggestion:hover {
  transform: scale(1.1);
}
h1 {
  color: #303030;
  margin: 0;
}
p {
  margin: 0;
}
.response {
  overflow: hidden;
  text-overflow: ellipsis;
}
::ng-deep .user-message table,
::ng-deep .other-message table,
::ng-deep .message-text.md table,
::ng-deep .message-text table {
  border-collapse: collapse;
  width: 100%;
  margin: 1em 0;
}
::ng-deep .user-message th,
::ng-deep .user-message td,
::ng-deep .other-message th,
::ng-deep .other-message td,
::ng-deep .message-text.md th,
::ng-deep .message-text.md td,
::ng-deep .message-text th,
::ng-deep .message-text td {
  border: 1px solid #ccc;
  padding: 6px 12px;
  text-align: left;
}
::ng-deep .user-message ol,
::ng-deep .user-message ul,
::ng-deep .other-message ol,
::ng-deep .other-message ul,
::ng-deep .message-text.md ol,
::ng-deep .message-text.md ul,
::ng-deep .message-text ol,
::ng-deep .message-text ul {
  margin: 0.75em 0 0.75em 1.5em;
  padding-left: 1.5em;
}
::ng-deep .user-message ol,
::ng-deep .other-message ol,
::ng-deep .message-text.md ol,
::ng-deep .message-text ol {
  list-style-type: decimal;
}
::ng-deep .user-message ul,
::ng-deep .other-message ul,
::ng-deep .message-text.md ul,
::ng-deep .message-text ul {
  list-style-type: disc;
}
::ng-deep .user-message li,
::ng-deep .other-message li,
::ng-deep .message-text.md li,
::ng-deep .message-text li {
  margin: 0.25em 0;
  line-height: 1.4;
  display: list-item;
}
::ng-deep .message-text.md {
  display: block;
  white-space: normal !important;
  margin: 0 !important;
  padding: 0 !important;
}
.message-icon.ai-logo {
  width: 24px;
  height: 24px;
  object-fit: contain;
  display: inline-block;
}
::ng-deep .user-message li:last-child,
::ng-deep .other-message li:last-child,
::ng-deep .message-text.md li:last-child,
::ng-deep .message-text li:last-child {
  margin-bottom: 1em;
}
::ng-deep .ai-chat-dialog .mat-mdc-dialog-container .mdc-dialog__container,
::ng-deep .ai-chat-dialog .mat-mdc-dialog-container .mdc-dialog__surface,
::ng-deep .ai-chat-dialog .mat-mdc-dialog-container .mat-mdc-dialog-surface {
  border-radius: 16px !important;
  overflow: hidden;
  background: transparent;
  box-shadow: none;
}
/*# sourceMappingURL=chat.component.css.map */
